import { common } from './common.icons';

export const IconPercentCircle = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-percent-circle ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
      viewBox="0 0 25 25"
      strokeWidth="2"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
    >
      <path d="M15.6287 9.37428L9.37819 15.6248M9.37819 9.37428H9.38861M15.6287 15.6248H15.6391M22.9209 12.4995C22.9209 18.253 18.2569 22.917 12.5034 22.917C6.75001 22.917 2.08594 18.253 2.08594 12.4995C2.08594 6.74611 6.75001 2.08203 12.5034 2.08203C18.2569 2.08203 22.9209 6.74611 22.9209 12.4995Z" />
    </svg>
  );
};
